/* global sendGaEvents */

//Return list of form to check and send Edit GA event
const getListOfFormsToCheck = () => {
  //Push form details to the form list for any other forms to send edit GA event.
  const formList = [];

  formList.push({
    formId: '#contact-us-form',
    gaEvent: {
      category: 'form-contact',
      action: 'form-edit',
      label: 'demo-form'
    },
    isEdited: false
  });
  formList.push({
    formId: '#contact-us-form-exit-intent-banner',
    gaEvent: {
      category: 'form-contact',
      action: 'form-edit',
      label: 'demo-form'
    },
    isEdited: false
  });

  return formList;
};

//Send GA event for edited form
const sendEditGAEvent = (form, event) => {
  return () => {
    if (!form.isEdited) {
      form.isEdited = true;
      sendGaEvents(event.category, event.action, event.label);
    }
  };
};

const onEditDemoForm = () => {
  const formList = getListOfFormsToCheck(); //Fetch the list of forms to listen for edit event.

  /*
    Attach event listner for each form to check whether form is made dirty or not.
    Then send GA event in the call back.
  */
  formList.forEach((form) => {
    const formElement = document.querySelector(form.formId);
    if (formElement) {
      const inputs = formElement.querySelectorAll('input');
      inputs.forEach((input) => {
        input.addEventListener('input', sendEditGAEvent(form, form.gaEvent), { once: true });
      });
      
      const employeeSelect = formElement.querySelector('[name="number_of_employees"]');
      if (employeeSelect) {
        employeeSelect.addEventListener('click', sendEditGAEvent(form, form.gaEvent));
      }
    }
  });
};

// Dropdown select - company size of demo form
const formSelectDropdown = () => {
  // Note: This function uses clickOutsideToHideContent from modal-utils
  // This should be imported if needed, or we can create a generic click outside handler

  // Opening and closing of dropdown options menu
  const formDropdowns = document.querySelectorAll('.form-dropdown.dropdown');
  formDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('click', (event) => {
      event.stopPropagation();
      
      // Close other dropdowns
      const otherDropdowns = document.querySelectorAll('.select-arrow-icon-primary.dropdown-closed-icon');
      otherDropdowns.forEach((icon) => {
        if (!event.currentTarget.contains(icon)) {
          icon.classList.remove('rotate-dropdown-icon');
        }
      });
      
      // Toggle current dropdown
      const currentIcon = event.currentTarget.querySelector('.select-arrow-icon-primary.dropdown-closed-icon');
      if (currentIcon) {
        currentIcon.classList.toggle('rotate-dropdown-icon');
      }
    });
  });

  // On selecting company size options list item
  const dropdownItems = document.querySelectorAll('.form-dropdown.dropdown');
  dropdownItems.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.stopPropagation();
      
      // Set the value of input to the selected option value
      const parentDropdown = event.currentTarget.closest('.dropdown');
      if (parentDropdown) {
        const input = parentDropdown.querySelector('input');
        if (input) {
          input.setAttribute('value', event.currentTarget.textContent);
        }
        
        // Update selected state
        const siblings = parentDropdown.querySelectorAll('.form-dropdown.dropdown');
        siblings.forEach((sibling) => sibling.classList.remove('selected'));
        event.currentTarget.classList.add('selected');
      }
    });
  });
};

export {
  formSelectDropdown,
  onEditDemoForm,
  getListOfFormsToCheck,
  sendEditGAEvent,
};